import script from "./CheckedProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckedProduct.vue?vue&type=script&lang=ts&setup=true"

import "./CheckedProduct.vue?vue&type=style&index=0&id=792fc744&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792fc744"]])

export default __exports__